import { Col, Row, Table } from 'antd';
import React, { memo } from 'react';

import './style.scss';
import ReportStatus from './component/report-status';
import LineChart from './component/line-chart';
import CopyContent from './component/copy-content';
import UserPie from './component/users-chart';
import CountProductPie from './component/count-product-chart';
import ShippingPie from './component/shipping-chart';
import NotePie from './component/note-chart';

interface IProps {
    data: any;
}
const Content: React.FC<IProps> = ({ data = {} }) => {
    return (
        <Row className="row-report-main">
            <Col span={24}>
                <ReportStatus dataReport={data} />
            </Col>
            <Row gutter={[20, 0]} className="row-order-status">
                <Col span={18}>
                    <LineChart dataReport={data} />
                </Col>
                <Col span={6} className="col-row-order-copy">
                    <CopyContent dataReport={data} />
                </Col>
            </Row>
            <Row gutter={[20, 15]} className="row-order-status">
                <Col span={12}>
                    <UserPie dataReport={data} />
                </Col>
                <Col span={12}>
                    <CountProductPie dataReport={data} />
                </Col>
                <Col span={12}>
                    <ShippingPie dataReport={data} />
                </Col>
                <Col span={12}>
                    <NotePie dataReport={data} />
                </Col>
            </Row>
        </Row>
    );
};

export default memo(Content);
